import axios from 'axios';

// Empty REACT_APP_BACKEND_URL means "same origin" — the normal setup,
// where this app is served by the API itself.
const API_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export const GOOGLE_LOGIN_URL = API_URL + '/auth/google/login';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  login: (creds) => axios.post(`${API_URL}/auth/login`, creds),
  getMe: () => axios.get(`${API_URL}/auth/me`, { headers: getAuthHeaders(), withCredentials: true }),
  registerUser: (data) => axios.post(`${API_URL}/auth/register`, data, { headers: getAuthHeaders() }),
  googleEnabled: () => axios.get(`${API_URL}/auth/google/enabled`),
  googleLogout: () => axios.post(`${API_URL}/auth/google-logout`, {}, { withCredentials: true }),

  // Assessments
  createAssessment: (data) => axios.post(`${API_URL}/assessments`, data, { headers: getAuthHeaders() }),
  listAssessments: (params) => axios.get(`${API_URL}/assessments`, { headers: getAuthHeaders(), params }),
  getAssessment: (id) => axios.get(`${API_URL}/assessments/${id}`, { headers: getAuthHeaders() }),
  deleteAssessment: (id) => axios.delete(`${API_URL}/assessments/${id}`, { headers: getAuthHeaders() }),

  // Candidate (public)
  getAssessmentByToken: (token) => axios.get(`${API_URL}/assess/${token}`),
  startAssessment: (token, data) => axios.post(`${API_URL}/assess/${token}/start`, data),
  getAssessmentQuestions: (token) => axios.get(`${API_URL}/assess/${token}/questions`),
  saveResponse: (data) => axios.post(`${API_URL}/responses`, data),
  logIntegrityEvent: (data) => axios.post(`${API_URL}/integrity-events`, data),

  // Reports
  getScorecard: (id) => axios.get(`${API_URL}/scorecards/${id}`, { headers: getAuthHeaders() }),
  getFullReport: (id) => axios.get(`${API_URL}/reports/${id}`, { headers: getAuthHeaders() }),
  regenerateAI: (id) => axios.post(`${API_URL}/scorecards/${id}/regenerate-ai`, {}, { headers: getAuthHeaders() }),
  getAnalysisPrompt: (id) => axios.get(`${API_URL}/scorecards/${id}/analysis-prompt`, { headers: getAuthHeaders() }),
  saveManualAnalysis: (id, text) => axios.post(`${API_URL}/scorecards/${id}/analysis`, { text }, { headers: getAuthHeaders() }),

  // Users
  listUsers: () => axios.get(`${API_URL}/users`, { headers: getAuthHeaders() }),
  updateUser: (id, updates) => axios.patch(`${API_URL}/users/${id}`, updates, { headers: getAuthHeaders() }),
  deleteUser: (id) => axios.delete(`${API_URL}/users/${id}`, { headers: getAuthHeaders() }),
  updateProfile: (data) => axios.put(`${API_URL}/auth/profile`, data, { headers: getAuthHeaders() }),

  // Compare
  compareCandidates: (ids) => axios.get(`${API_URL}/compare?ids=${ids.join(',')}`, { headers: getAuthHeaders() }),

  // Settings
  getBranding: () => axios.get(`${API_URL}/branding`),
  getSettings: () => axios.get(`${API_URL}/settings`, { headers: getAuthHeaders() }),
  updateSettings: (data) => axios.patch(`${API_URL}/settings`, data, { headers: getAuthHeaders() }),
  uploadLogo: (formData) => axios.post(`${API_URL}/settings/logo`, formData, { headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' } }),

  // Audit
  getAuditLogs: (params) => axios.get(`${API_URL}/audit-logs`, { headers: getAuthHeaders(), params }),
  getAuditActions: () => axios.get(`${API_URL}/audit-logs/actions`, { headers: getAuthHeaders() }),
};
